import { AxiosPromise } from 'axios';
import {
    DashboardSettings,
    DefaultEditors
} from '@dev/ee-api/ee-api-models';

import { request } from './request';


export const dashboardSettingsGet = (): AxiosPromise<DashboardSettings> => {
    const { Accounts } = request();

    return Accounts.accountsDashboardsettingsGet();
};

export const defaultEditorPut = (defaultEditor: DefaultEditors): AxiosPromise<DefaultEditors> => {
    const { Accounts } = request();

    return Accounts.accountsDashboardsettingsDefaulteditorPut(defaultEditor);
};